import {
  IPeerGroupsProps,
  getPeerGroupData,
  IFilter,
} from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";
import { Row, Col, Panel } from "react-bootstrap";
import { VisualizationFive } from "app/components/visualizations/PeerGroups/GIV/VisualizationFive";
import { VisualizationFour } from "app/components/visualizations/PeerGroups/GIV/VisualizationFour";
import { TabHeader } from "app/components/tabs/header";
import TabFootnote from "app/components/tabs/TabFootnote";

export interface IOtherState {
  data: any[];
  currentPeerGroup: any[];
  filters: IFilter;
}

export class Giving extends React.Component<IPeerGroupsProps, IOtherState> {
  state: IOtherState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  };

  componentDidMount() {
    this.pullData(this.props.filters);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters);
      });
    }
  }

  pullData(filters: IFilter) {
    const requestBody = {
      action: "getGivTab",
      request: { assetLevel: filters.assetLevel },
    };
    getPeerGroupData(requestBody)
      .then((response: any[]) => {
        const currentPeerGroup = response.find(
          (dataPoint) => dataPoint.filterId === this.props.filters.assetLevel
        );
        this.setState({ data: response, currentPeerGroup });
      })
      .catch((error) => console.error(error));
  }

  render() {
    const { currentPeerGroup, data } = this.state;
    const { assetLevel, assetName } = this.props.filters;
    return (
      <div>
        <TabHeader filters={this.props.filters} label="Giving" />
        <Panel>
          <Row>
            <Col sm={12} md={6} className="text-center">
              <h4>Total Giving*</h4>
              <h4 className="text-primary">
                {currentPeerGroup && currentPeerGroup["Giv_T_B_GivTotal"]}
              </h4>
            </Col>
            <Col sm={12} md={6}>
              <p>
                {currentPeerGroup && currentPeerGroup["Giv_T_B_Placeholder1"]}
              </p>
            </Col>
          </Row>
          <Row>
            <Col
              sm={12}
              md={3}
              className="fontSize1_7"
              style={{ padding: "35px" }}
            >
              <p>{currentPeerGroup && currentPeerGroup["Giv_T_B_GivDef"]}</p>
              <p>
                {currentPeerGroup &&
                  currentPeerGroup["Giv_T_B_GivVisual4Text1"]}
              </p>
              <p>
                {currentPeerGroup &&
                  currentPeerGroup["Giv_T_B_GivVisual4Text2"]}
              </p>
            </Col>
            <Col sm={12} md={9}>
              <VisualizationFour
                data={data}
                filters={{ assetName, assetLevel }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <TabFootnote>
                {currentPeerGroup && currentPeerGroup["Giv_T_B_Footnote1"]}
              </TabFootnote>
            </Col>
          </Row>
          <Row>
            <Col
              sm={12}
              md={3}
              className="fontSize1_7"
              style={{ padding: "35px" }}
            >
              <p>
                {currentPeerGroup &&
                  currentPeerGroup["Giv_T_B_GivVisual5Text1"]}
              </p>
              <p>
                {currentPeerGroup &&
                  currentPeerGroup["Giv_T_B_GivVisual5Text2"]}
              </p>
            </Col>
            <Col sm={12} md={9}>
              <VisualizationFive
                data={data}
                filters={{ assetName, assetLevel }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <TabFootnote>
                <p>
                  {currentPeerGroup && currentPeerGroup["Giv_T_B_Footnote1"]}
                </p>
                <p>
                  {currentPeerGroup && currentPeerGroup["Giv_T_B_Footnote2"]}
                </p>
              </TabFootnote>
            </Col>
          </Row>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/Giving.tsx